/*
 * A helper function that is passed a string like 'white' and returns a tailwind text color.
 */

// This color map is based off of the color map in getBackgroundColor. Thus, the color passed to this function should be a background color. So, when the background is white, the rectangle's color is base-200. This relationships ensures that the font color will always match the background color.
const rectangleColorMap = {
  white: `text-base-200`,
  black: `text-base-content`,
  blue: `text-primary`,
  gray: `text-base-200`,
  cyanBlueGradient: `text-white opacity-20`,
  animatedCyanBlueGradient: `text-white opacity-20`,
};

const getBackgroundRectanglesColor = color => rectangleColorMap[color];

export default getBackgroundRectanglesColor;
